import { of } from 'rxjs';
import Global from '../../global-selectors';
import { bulkLoadSalesOrders$ } from '../../bulkload/bulkload.observables';

const thirtySeconds = 30 * 1000;

const isEntityOutDated = (entitiyLastLoadedDateTime, isLoading) => {
  const now = new Date();
  const isOutOfDate = entitiyLastLoadedDateTime ? now - entitiyLastLoadedDateTime > thirtySeconds : true;
  return !isLoading && isOutOfDate;
};

export const bulkLoadOutOfDateEntities = (salesOrderIds, state) => {
  const outOfDateSalesOrderIds = salesOrderIds.filter((salesOrderId) => {
    const isLoading = Global.selectEntitiesSalesOrderIsLoading(state, {
      salesOrderId,
    });
    return isEntityOutDated(
      Global.selectEntitiesSalesOrderProperty(state, {
        salesOrderId,
        property: 'lastLoadedDateTime',
      }),
      isLoading,
    );
  });

  return outOfDateSalesOrderIds.length > 0 ? bulkLoadSalesOrders$(outOfDateSalesOrderIds) : of(null);
};
